import React from "react";
import { Button, Form, SelectBox } from "../../../primary";
import { CloseWarning } from "../../../secondary";
import { CANCEL_BTN, SAVE_BTN } from "../../../../constants";
import style from "../../Patients/characteristic.module.scss";
import { PERMISSIONS } from "../../../../constants/permissions";

export const CharacteristicProgressEditMode = ({
  styles,
  assessmentDetails,
  assessmentDetailsNew,
  woundProgressOptions,
  isCompleted,
  isProgressResolve,
  // historyCauseCompleted,
  characteristicTabsData,
  register,
  handleSubmit,
  doSubmit,
  setFormChangesConfirm,
  setClickCancel,
  woundProgressResolve,
  handleYesProgress,
  handleNoProgress,
  isSignedLocked,
}) => {
  // if (historyCauseCompleted === 0) {
  //   return (
  //     <div className={`${styles.errorTissueNull} col-11 text-danger text-center`}>{"Please select History/Cause before selecting Progress"}</div>
  //   );
  // }

  // if (characteristicTabsData?.find((item) => item?.key === "tissuetype")?.isCompleted === 0) {
  //   return (
  //     <div className={`${styles.errorTissueNull} col-11 text-danger text-center`}>{"Please select Tissue Type(s) before selecting Progress"}</div>
  //   );
  // }

  if (characteristicTabsData?.find((item) => item?.category === "History/Cause")?.isCompleted === 0) {
    return (
      <div className={`${styles.errorTissueNull} col-11 text-danger text-center`}>{"Please select History/Cause before selecting Progress"}</div>
    );
  }

  if (characteristicTabsData?.find((item) => item?.category === "Tissue Type")?.isCompleted === 0) {
    return (
      <div className={`${styles.errorTissueNull} col-11 text-danger text-center`}>{"Please select Tissue Type(s) before selecting Progress"}</div>
    );
  }

  // if (characteristicTabsData?.find((item) => item?.key === "tissuetype")?.isCompleted === 0) {
  //   return (
  //     <div className={`${styles.errorTissueNull} col-11 text-danger text-center`}>{"Please select Tissue Type(s) before selecting Progress"}</div>
  //   );
  // }

  return (
    <>
      {isProgressResolve && (
        <CloseWarning message="Do you want to set all the measurement to 0?" yesFn={() => handleYesProgress(1)} noFn={handleNoProgress} />
      )}
      <div className="container-fluid p-0">
        <div className={`${styles.patient_content} p-0`}>
          <Form
            setFormChangesConfirm={setFormChangesConfirm}
            className={"col-12 p-0"}
            onSubmit={handleSubmit(doSubmit)}
            requiredPermission={PERMISSIONS.ASSESSMENT}
            disabled={isSignedLocked}
          >
            <SelectBox
              id="progress"
              name="progress"
              label="Wound Progress: "
              classes={{
                column: `col-12 ${styles.col_spec}`,
                inputClassName: styles.basic_select,
                labelClassName: `col-4 col-form-label ${styles.label_spec}`,
                inputColumn: `col-6 p-0 ${styles.select_wrapper}`,
              }}
              optionValue={woundProgressOptions}
              validator={register()}
              placeholder="Select"
              defaultValue={assessmentDetailsNew?.woundStage ? assessmentDetails.woundStage : assessmentDetails?.reEvalSequence === 0 ? "new" : null}
              onChange={woundProgressResolve}
            />

            <div className="col-12 p-0 mt-4">
              <div className="offset-4">
                {isCompleted === 0 ? (
                  <Button type="submit" value="Next" classes={{ className: `btn pl-1 mr-4 ${style.btn_primary}` }} disabled={isSignedLocked} />
                ) : (
                  <>
                    <Button type="submit" value={SAVE_BTN} classes={{ className: `btn pl-1 mr-4 ${style.btn_primary}` }} disabled={isSignedLocked} />
                    <Button
                      type="button"
                      value={CANCEL_BTN}
                      classes={{ className: `btn ml-2 ${style.btn_scondary}` }}
                      onClick={() => setClickCancel(true)}
                      disabled={isSignedLocked}
                    />
                  </>
                )}
              </div>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};
